import { render, staticRenderFns } from "./RtcPrivateAcceptor.vue?vue&type=template&id=fb467986&scoped=true"
import script from "./RtcPrivateAcceptor.vue?vue&type=script&lang=js"
export * from "./RtcPrivateAcceptor.vue?vue&type=script&lang=js"
import style0 from "./RtcPrivateAcceptor.vue?vue&type=style&index=0&id=fb467986&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb467986",
  null
  
)

export default component.exports